import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { i18n as i18nHandler } from 'view-design';
import iview_ru from 'view-design/dist/locale/ru-RU';
import iview_en from 'view-design/dist/locale/en-US';
import iview_id from 'view-design/dist/locale/id-ID';
import { Lang } from '@shared/helpers/lang';

Vue.use(VueI18n);
Vue.locale = () => {};

const i18n = new VueI18n({
  locale: Lang.getBrowserLocale(),
  messages: {
    en: {
      ...require('@app/assets/lang/en').default,
      ...iview_en
    },
    ru: {
      ...require('@app/assets/lang/ru').default,
      ...iview_ru
    },
    id: {
      ...require('@app/assets/lang/id').default,
      ...iview_id
    }
  }
});

VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
  if (this.locale === 'ru') {
    if (choice === 0) {
      return 0;
    }

    const teen = choice > 10 && choice < 20;
    const endsWithOne = choice % 10 === 1;

    if (!teen && endsWithOne) {
      return 1;
    }

    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
      return 2;
    }

    return choicesLength < 4 ? 2 : 3;
  }

  choice = Math.abs(choice);

  if (choicesLength === 2) {
    return choice ? (choice > 1 ? 1 : 0) : 1;
  }

  return choice ? Math.min(choice, 2) : 0;
};

i18nHandler((key, value, params) => {
  return isNaN(value) ? i18n.t(key, value) : i18n.tc(key, value, params);
});

export default i18n;
